class UtilizationGraphManager {
  constructor(data, filterType = '') {
    this.filterType = filterType;

    this.data = Object.fromEntries(
      Object.entries(data.result)
        .filter(([key, _]) => !!key)
    );
   this.customerCount = data.customer_count
    ? Object.fromEntries(
        Object.entries(data.customer_count)
          .filter(([key, value]) => !!value)
          .sort(([key1, value1], [key2, value2]) => {
            if (String(key1).toLowerCase() < String(key2).toLowerCase()) return -1;
            if (String(key1).toLowerCase() > String(key2).toLowerCase()) return 1;
            return 0;
          })
          .slice(0, 50)
      )
    : null;
    this.type = data.type
    this.total = this.getTotal(this.data);
    this.bardata = this.getBarData(this.data, this.total, this.customerCount);
    this.barlabels = this.getBarLables(this.customerCount || this.data);

    if (['department', 'location'].includes(this.filterType)) {
      const combined = this.barlabels.map((label, i) => ({
        label,
        value: this.bardata[i],
      }));
      combined.sort((a, b) => b.value - a.value);

      this.barlabels = combined.map((item) => item.label);
      this.bardata = combined.map((item) => item.value);
    } else {
      const combined = Object.keys(this.customerCount || this.data).map((label) => ({
        label,
        value: this.bardata[this.barlabels.indexOf(label)],
      }));

      this.barlabels = combined.map((item) => item.label);
      this.bardata = combined.map((item) => item.value);
    }

    this.maxUtilizationValue = null;
    this.barBgColors = this.getBarBgColors.apply(this, [this.customerCount || this.data]);
    this.bardata = this.bardata;
  }

  apiResponse = () => {
    return this.data;
  };

  getTotal(data) {
    if (data) {
      if(this.type === 'spending_account'){
        let total = Object.values(data).reduce((total, num) => total + num, 0);
       return total / 1000
      }
      return Object.values(data).reduce((total, num) => total + num, 0);
    }
  }

  getBarData(data, total, categoryWiseTotalCount = null) {
    let total_sum = 0,
      res = [];
    if (data) {
      if (this.type === "spending_account") {
        res = Object.values(data).map((value, index) => {
          let val = Math.round(value / 1000);
          return val;
        });
      } else if (categoryWiseTotalCount) {
        res = Object.keys(categoryWiseTotalCount).map((key, index) => {
          if (!data[key] || !categoryWiseTotalCount[key]) {
            return 0;
          }
          let val = Math.round((data[key] / categoryWiseTotalCount[key]) * 100);
          return val;
        });
      } else {
        res = Object.values(data).map((value, index) => {
          let val = Math.round((value / total) * 100);
          total_sum += val;
          if (total_sum > 100) {
            val = val - (total_sum - 100);
            total_sum = 100;
          }
          return val;
        });
        if (total_sum > 0 && total_sum < 100) {
          res[res.length - 1] += 100 - total_sum;
        }
      }
    }
    return res;
  }

  getBarLables(data) {
    if (data) {
      return Object.keys(data);
    }
  }

  getBarBgColors(data) {
    if (data) {
      const values = Object.values(data);
      let bgcolors = new Array(values.length).fill('#C7CDE0');
      const maxInd = this.getMaxIndex(values);
      this.maxUtilizationValue = values[maxInd];
      bgcolors[maxInd] = '#5A8BED';
      return bgcolors;
    }
  }

  getMaxIndex(arr) {
    let maxInd = 0;
    for (let [ind, ele] of arr.entries()) {
      if (ele > arr[maxInd]) maxInd = ind;
    }
    return maxInd;
  }
}

export default UtilizationGraphManager;
